import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import { useSelector, useDispatch } from 'react-redux'
import { setInterests } from '../actions'
import Interest from './Interest'

const contVariant = {
  hidden: {
    x: "100vw"
  },
  visible: {
    x: 0,
    transition: {
      delay: 0.1,
      type: "spring",
      stiffness: 80,
      mass: 0.4,
      damping: 8
    }
  }
}
const linkVariant = {
  hover: {
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    transition: {
      duration: 0.2
    }
  }
}
export default function Interests() {
  const resumeInterests = useSelector(states => states.resumeData).interests
  const dispatch = useDispatch()
  const history = useHistory();
  const [exInterests, setExInterests] = useState()
  const [interests, setResumeInterests] = useState(() => {
    return resumeInterests
  })
  const [interestValue, setInterestValue] = useState('')
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setInterests(interests))
    history.push("/introduction");
  }
  function chooseRandomInterest() {
    let index = Math.floor(Math.random() * exInterests.socialInterest.length)
    let choosenInterest = exInterests.socialInterest[index]
    setInterestValue(choosenInterest)
  }
  function addInterest(e) {
    e.preventDefault();
    setResumeInterests((prevInterests) => {
      if (prevInterests.includes(interestValue))
        return prevInterests
      return [...prevInterests, interestValue]
    })
  }
  function removeInterest(id) {
    setResumeInterests((prevInterests) => {
      return prevInterests.filter((interest, index) => index !== id)
    })
  }
  useEffect(() => {
    fetch("https://skyresume-7siu.onrender.com/getinterests")
      .then(response => response.json())
      .then(json => setExInterests(json.body.interestSet))
  }, [])
  useEffect(() => {
    setInterestValue('')
  }, [interests])
  return (
    <motion.div className="container" exit={{ x: "-100vw" }}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <div><h1><i className="fas fa-book-reader mr-2"></i>Interests</h1>
          <button className="text-light my-2 py-2 b-1 random-btn" onClick={chooseRandomInterest}>choose random</button></div>
        <form onSubmit={addInterest}>
          <div className="input-btn">
            <input type="text" value={interestValue} onChange={(e) => setInterestValue(e.target.value)} placeholder="add interest then press enter" required />
            <span className="pb-1 mb-2"><button type="submit"><i class="fas fa-plus"></i></button></span>
          </div><br />
        </form>
        <ul>
          {interests.map((interest, index) => {
            return (<Interest interest={interest} key={index} id={index} removeInterest={removeInterest} />)
          })}
        </ul>
        {interests != 0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}
      </motion.div>
    </motion.div>
  );
}
